import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/step4.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')